export const PROFESSIONAL_DATA_NAMES = {
  PROFESSIONAL_DATA_EMPLOYMENT_FORM: "PROFESSIONAL_DATA_EMPLOYMENT_FORM",
  PROFESSIONAL_DATA_COMPANY_FORM: "PROFESSIONAL_DATA_COMPANY_FORM",
  PROFESSIONAL_DATA_ADDITIONAL_SELF_EMPLOYED_FORM:
    "PROFESSIONAL_DATA_ADDITIONAL_SELF_EMPLOYED_FORM",
};

export const PROFESSIONAL_POSITION_FILTER = [
  "indefinite_employed",
  "fixed_discontinuous_employed",
  "temporary_employed",
  "civil_servant",
  "trainee",
  "casualty_worker",
  "self_employed",
];

export const employmentStatusTypesConfig = {
  INDEFINITE_EMPLOYED: {
    name: "INDEFINITE_EMPLOYED",
    value: "indefinite_employed",
  },
  TEMPORARY_EMPLOYED: {
    name: "TEMPORARY_EMPLOYED",
    value: "temporary_employed",
  },
  FIXED_DISCONTINUOUS_EMPLOYED: {
    name: "FIXED_DISCONTINUOUS_EMPLOYED",
    value: "fixed_discontinuous_employed",
  },
  CIVIL_SERVANT: {
    name: "CIVIL_SERVANT",
    value: "civil_servant",
  },
  SELF_EMPLOYED: {
    name: "SELF_EMPLOYED",
    value: "self_employed",
  },
  TRAINEE: {
    name: "TRAINEE",
    value: "trainee",
  },
  CASUALTY_WORKER: {
    name: "CASUALTY_WORKER",
    value: "casualty_worker",
  },
  UNEMPLOYED: {
    name: "UNEMPLOYED",
    value: "unemployed",
  },
  RETIRED: {
    name: "RETIRED",
    value: "retired",
  },
  PENSIONER: {
    name: "PENSIONER",
    value: "pensioner",
  },
  STUDENT: {
    name: "STUDENT",
    value: "student",
  },
  RENTIER: {
    name: "RENTIER",
    value: "rentier",
  },
  WIDOWS_INCOME: {
    name: "WIDOWS_INCOME",
    value: "widows_income",
  },
  OTHER_PROFESSION: {
    name: "OTHER_PROFESSION",
    value: "other",
  },
};

export const employmentStatusTypeWithoutOtherConfig = {
  INDEFINITE_EMPLOYED: {
    name: "INDEFINITE_EMPLOYED",
    value: "indefinite_employed",
  },
  TEMPORARY_EMPLOYED: {
    name: "TEMPORARY_EMPLOYED",
    value: "temporary_employed",
  },
  FIXED_DISCONTINUOUS_EMPLOYED: {
    name: "FIXED_DISCONTINUOUS_EMPLOYED",
    value: "fixed_discontinuous_employed",
  },
  CIVIL_SERVANT: {
    name: "CIVIL_SERVANT",
    value: "civil_servant",
  },
  SELF_EMPLOYED: {
    name: "SELF_EMPLOYED",
    value: "self_employed",
  },
  TRAINEE: {
    name: "TRAINEE",
    value: "trainee",
  },
  CASUALTY_WORKER: {
    name: "CASUALTY_WORKER",
    value: "casualty_worker",
  },
  UNEMPLOYED: {
    name: "UNEMPLOYED",
    value: "unemployed",
  },
  RETIRED: {
    name: "RETIRED",
    value: "retired",
  },
  PENSIONER: {
    name: "PENSIONER",
    value: "pensioner",
  },
  STUDENT: {
    name: "STUDENT",
    value: "student",
  },
  RENTIER: {
    name: "RENTIER",
    value: "rentier",
  },
  WIDOWS_INCOME: {
    name: "WIDOWS_INCOME",
    value: "widows_income",
  },
};

export const professionalPositionTypesForCivilServantConfig = {
  POLICE_AND_MILITARY: {
    name: "POLICE_AND_MILITARY",
    value: "police_and_military",
  },
  DIPLOMATIC: {
    name: "DIPLOMATIC",
    value: "diplomatic",
  },
  CIVIL_SERVANT_A1: {
    name: "CIVIL_SERVANT_A1",
    value: "civil_servant_a1",
  },
  CIVIL_SERVANT_A2: {
    name: "CIVIL_SERVANT_A2",
    value: "civil_servant_a2",
  },
  CIVIL_SERVANT_B: {
    name: "CIVIL_SERVANT_B",
    value: "civil_servant_b",
  },
  CIVIL_SERVANT_C1: {
    name: "CIVIL_SERVANT_C1",
    value: "civil_servant_c1",
  },
  CIVIL_SERVANT_C2: {
    name: "CIVIL_SERVANT_C2",
    value: "civil_servant_c2",
  },
  CIVIL_SERVANT_E: {
    name: "CIVIL_SERVANT_E",
    value: "civil_servant_e",
  },
  CIVIL_SERVANT_G1: {
    name: "CIVIL_SERVANT_G1",
    value: "labor_staff_g1",
  },
  CIVIL_SERVANT_G2: {
    name: "CIVIL_SERVANT_G2",
    value: "labor_staff_g2",
  },
  CIVIL_SERVANT_G3: {
    name: "CIVIL_SERVANT_G3",
    value: "labor_staff_g3",
  },
  CIVIL_SERVANT_G4: {
    name: "CIVIL_SERVANT_G4",
    value: "labor_staff_g4",
  },
  CIVIL_SERVANT_G5: {
    name: "CIVIL_SERVANT_G5",
    value: "labor_staff_g5",
  },
};

export const professionalPositionTypesForNonCivilServantConfig = {
  ADMINISTRATIVE: {
    name: "ADMINISTRATIVE",
    value: "administrative",
  },
  MANAGING_DIRECTOR: {
    name: "MANAGING_DIRECTOR",
    value: "managing_director",
  },
  MANAGER: {
    name: "MANAGER",
    value: "manager",
  },
  COMPANY_OWNER: {
    name: "COMPANY_OWNER",
    value: "company_owner",
  },
  TECHNICIANS_AND_PROFESSIONAL: {
    name: "TECHNICIANS_AND_PROFESSIONAL",
    value: "technicians_and_professional",
  },
  SHOP_ASSISTANT: {
    name: "SHOP_ASSISTANT",
    value: "shop_assistant",
  },
  COMMERCIAL_AND_SALES_PERSON: {
    name: "COMMERCIAL_AND_SALES_PERSON",
    value: "commercial_and_sales_person",
  },
  LABOR_WORKER: {
    name: "LABOR_WORKER",
    value: "labor_worker",
  },
  ENGINEER: {
    name: "ENGINEER",
    value: "engineer",
  },
  ARCHITECT: {
    name: "ARCHITECT",
    value: "architect",
  },
  LAWYER_OR_NOTARY_ATTORNEY: {
    name: "LAWYER_OR_NOTARY_ATTORNEY",
    value: "lawyer_or_notary_attorney",
  },
  DOCTOR_OR_DENTIST: {
    name: "DOCTOR_OR_DENTIST",
    value: "doctor_or_dentist",
  },
  PHARMACEUTICAL: {
    name: "PHARMACEUTICAL",
    value: "pharmaceutical",
  },
  VETERINARY: {
    name: "VETERINARY",
    value: "veterinary",
  },
  TEACHER: {
    name: "TEACHER",
    value: "teacher",
  },
  JOURNALIST: {
    name: "JOURNALIST",
    value: "journalist",
  },
  FARMER_OR_RANCHER: {
    name: "FARMER_OR_RANCHER",
    value: "farmer_or_rancher",
  },
  TRANSPORTER: {
    name: "TRANSPORTER",
    value: "transporter",
  },
  PROFESSIONAL_ATHLETE: {
    name: "PROFESSIONAL_ATHLETE",
    value: "professional_athlete",
  },
  ARTIST: {
    name: "ARTIST",
    value: "artist",
  },
  RELIGIOUS: {
    name: "RELIGIOUS",
    value: "religious",
  },
};

export const companyActivitiesTypesConfig = {
  AGRICULTURE_LIVESTOCK_FISHERIES: {
    name: "AGRICULTURE_LIVESTOCK_FISHERIES",
    value: "agriculture_livestock_fisheries",
  },
  MINING_METALLURGY: {
    name: "MINING_METALLURGY",
    value: "mining_metallurgy",
  },
  GROCERY: {
    name: "GROCERY",
    value: "grocery",
  },
  TEXTILE_MANUFACTURE: {
    name: "TEXTILE_MANUFACTURE",
    value: "textile_manufacture",
  },
  WOOD: {
    name: "WOOD",
    value: "wood",
  },
  GRAPHICS_ARTS_EDITION: {
    name: "GRAPHICS_ARTS_EDITION",
    value: "graphics_arts_edition",
  },
  CHEMISTRY: {
    name: "CHEMISTRY",
    value: "chemistry",
  },
  MECHANICAL_MACHINERY: {
    name: "MECHANICAL_MACHINERY",
    value: "mechanical_machinery",
  },
  ENERGY_DISTRIBUTION_ELECTRICAL_SUPPLY: {
    name: "ENERGY_DISTRIBUTION_ELECTRICAL_SUPPLY",
    value: "energy_distribution_electrical_supply",
  },
  OTHER_UNQUALIFIED_SERVICES: {
    name: "OTHER_UNQUALIFIED_SERVICES",
    value: "other_unqualified_services",
  },
  OTHER_QUALIFIED_SERVICES: {
    name: "OTHER_QUALIFIED_SERVICES",
    value: "other_qualified_services",
  },
  BUILDING: {
    name: "BUILDING",
    value: "building",
  },
  COMMERCE: {
    name: "COMMERCE",
    value: "commerce",
  },
  PEDDLING: {
    name: "PEDDLING",
    value: "peddling",
  },
  TRANSPORT_TERRESTRIAL_MESSAGING: {
    name: "TRANSPORT_TERRESTRIAL_MESSAGING",
    value: "transport_terrestrial_messaging",
  },
  OTHER_TRANSPORTS: {
    name: "OTHER_TRANSPORTS",
    value: "other_transports",
  },
  TAXI_DRIVER: {
    name: "TAXI_DRIVER",
    value: "taxi_driver",
  },
  TELECOMMUNICATIONS_MAIL: {
    name: "TELECOMMUNICATIONS_MAIL",
    value: "telecommunications_mail",
  },
  BARS_SERVICES: {
    name: "BARS_SERVICES",
    value: "bars_services",
  },
  I_PLUS_D: {
    name: "I_PLUS_D",
    value: "i_plus_d",
  },
  ADVOCACY_JOURNALISM: {
    name: "ADVOCACY_JOURNALISM",
    value: "advocacy_journalism",
  },
  SECURE_FINANCIAL_SERVICES: {
    name: "SECURE_FINANCIAL_SERVICES",
    value: "secure_financial_services",
  },
  FINANCIAL_SERVICES_INSURANCE: {
    name: "FINANCIAL_SERVICES_INSURANCE",
    value: "financial_services_insurance",
  },
  IT_CONSULTANT_AUDITOR: {
    name: "IT_CONSULTANT_AUDITOR",
    value: "it_consultant_auditor",
  },
  ARCHITECTURE_ENGINEERING: {
    name: "ARCHITECTURE_ENGINEERING",
    value: "architecture_engineering",
  },
  VETERINARY_MEDICINE: {
    name: "VETERINARY_MEDICINE",
    value: "veterinary_medicine",
  },
  PUBLIC_ADMINISTRATIONS: {
    name: "PUBLIC_ADMINISTRATIONS",
    value: "public_administrations",
  },
  ARMED_FORCES: {
    name: "ARMED_FORCES",
    value: "armed_forces",
  },
  EDUCATION: {
    name: "EDUCATION",
    value: "education",
  },
  HOLIDAY_SHOWS_SHOWS: {
    name: "HOLIDAY_SHOWS_SHOWS",
    value: "holiday_shows_shows",
  },
  SPORTS: {
    name: "SPORTS",
    value: "sports",
  },
};
